/** @format */

import React, { useEffect, useState } from "react";
import { Form, Button, ButtonGroup } from "react-bootstrap";
import "react-phone-input-2/lib/style.css"; // Import the phone input styles

import SwiperCore from "swiper";
import { Navigation, Autoplay } from "swiper/modules";
import { useNavigate } from "react-router-dom";

// install Swiper modules
SwiperCore.use([Navigation, Autoplay]);

const OTPForm = () => {
  const [formData, setFormData] = useState({});
  const nav = useNavigate();

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    nav("/auth/sign-in/user");
  };

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <br />
        <Form.Group controlId="otp" className="form-group text-start">
          <Form.Label className="form-label fw-bold">Enter the OTP</Form.Label>
          <Form.Control
            type="text"
            name="otp"
            value={formData.otp || ""}
            onChange={handleInputChange}
          />
        </Form.Group>
        <ButtonGroup className="d-flex justify-content-between mt-4">
          <Button variant="success" type="submit" onClick={handleSubmit}>
            Submit
          </Button>
        </ButtonGroup>
      </Form>
    </>
  );
};

export default OTPForm;
